<template>
  <!-- onclick="void(0)" fixes non registering click events in iOS Safari -->
  <div
    id="app"
    onclick="void(0)">
    <header class="example-header">
      <img
        alt="Vue logo"
        src="./assets/logo.png"
        class="example-header__logo">
      <h1 class="main-headline">Vue a11y Combobox</h1>
    </header>
    <main>
      <section class="demo">
        <h2>What is this?</h2>
        <p><code>vue-a11y-combobox</code> is an adaption of the WAI-ARIA guides for building a Combobox. Okay, cool. To cut down on the jargon: WAI-ARIA is a specification to write accessible web applications. And a combobox is a combination of input and a list of results. Ah, cool.</p>
        <p>Try to enter some letters into the input below. Suggestion will automatically appear. If you select one, its full text will be shown.</p>
        <a11y-combobox
          :items="filteredPosts"
          :is-styled="true"
          no-results-message="Sorry, but no results could be found …"
          input-label="Search for posts"
          @input="filterItems"
          @foundResult="showResult"
        />
        <transition name="fade-up">
          <article
            v-if="activePost"
            :key="activePost.id"
            class="active-post"
          >
            <h2>{{ activePost.title.toUpperCase() }}</h2>
            <p>{{ activePost.body }}</p>
          </article>
        </transition>
        <h2>Use this</h2>
        <p>This component <a href="https://www.npmjs.com/package/vue-a11y-combobox">available on npm</a>.</p>
        <p>You can find the source code in the <a href="https://github.com/ovlb/vue-a11y-combobox">GitHub repository</a>.</p>
      </section>
    </main>
    <footer class="example-footer">
      <h2 class="small">Who maintains this?</h2>
      <p>This project is maintained by <a href="https://www.ovl.design" title="Homepage of Oscar">Oscar</a>.</p>
    </footer>
  </div>
</template>

<script>
import A11yCombobox from 'vue-a11y-combobox'

export default {
  name: 'App',
  components: {
    A11yCombobox
  },
  data () {
    return {
      posts: [],
      filteredPosts: [],
      activePost: null
    }
  },
  mounted () {
    fetch('https://jsonplaceholder.typicode.com/posts/')
      .then((response) => response.json())
      .then((json) => {
        this.posts = json
      })
  },
  methods: {
    filterItems (value) {
      this.filteredPosts = this.posts.reduce((acc, item) => {
        return item.title.toLowerCase().includes(value.toLowerCase())
          ? acc.concat(Object.assign({}, { id: item.id, title: item.title }))
          : acc
      }, [])
    },
    showResult (id) {
      this.activePost = this.posts.find((post) => post.id === id)
    }
  }
}
</script>

<style>
body {
  color: #2c3e50;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  margin: 0;
  min-height: 100vh;
  padding: 4vmin 2vmin 2vmin;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.example-header {
  align-items: center;
  display: flex;
  margin-bottom: 6vmin;
}

.example-header__logo {
  margin-right: 0.5rem;
  max-width: 3rem;
}

.demo {
  border-block-end: 1px solid #2c3e50;
  margin: 0 auto 1.5rem;
  max-width: 60ch;
  padding-bottom: 0.5rem;
}

.active-post {
  margin: 2vmin auto;
  max-width: 60ch;
}

h2.small {
  margin-bottom: 0;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.01em;
  word-spacing: 0.01em;
}

.example-footer {
  margin: 3rem auto 0;
  max-width: 60ch;
}
</style>
